export default __webpack_public_path__ + "static/media/No.2-2.8df58401.jpg";